import { Routes } from '@angular/router';
import { MainPageComponent } from '@app/pages';
import { MenuTabComponent } from '@app/pages/main-page/menu-tab/menu-tab.component';
import { HomeTabComponent } from '@app/pages/main-page/home-tab/home-tab.component';
import { RealSportsTabComponent } from '@app/pages/main-page/real-sports-tab/real-sports-tab.component';
import { MlseFoundationTabComponent } from '@app/pages/main-page/mlse-foundation-tab/mlse-foundation-tab.component';
import { YourSeatViewTabComponent } from '@app/pages/main-page/your-seat-view-tab/your-seat-view-tab.component';
import { SpecialOfferComponent } from '@app/pages/main-page/special-offer/special-offer.component';

export const appRoutes: Routes = [
  {
    path: 'main',
    component: MainPageComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeTabComponent,
        data: { animation: 'HomeTab', screen: 'Home' },
      },
      {
        path: 'menu',
        component: MenuTabComponent,
        data: { animation: 'MenuTab', screen: 'Menu' },
      },
      {
        path: 'special-offer',
        component: SpecialOfferComponent,
        data: { animation: 'SpecialOffer', screen: 'SpecialOffer' },
      },
      {
        path: 'real-sports',
        component: RealSportsTabComponent,
        data: { animation: 'RealSportsTab', screen: 'RealSports' },
      },
      {
        path: 'mlse-foundation',
        component: MlseFoundationTabComponent,
        data: { animation: 'MlseFoundationTab', screen: 'MlseFoundation' },
      },
      {
        path: 'your-seat-view',
        component: YourSeatViewTabComponent,
        data: { animation: 'YourSeatViewTab', screen: 'YourSeatView' },
      },
    ],
  },
];
